const SCALEMODE_NONE = 'none';
const SCALEMODE_BLEND = 'blend';

export { SCALEMODE_BLEND, SCALEMODE_NONE };
